<script>
import { actions, getters } from 'views/utils'
import mockConstructions from 'mixins/mock/constructions.json'
import mockInverters from 'mixins/mock/inverters.json'
import mockModules from 'mixins/mock/modules.json'
import mockProjectsProd from 'mixins/mock/projectsProd.json'
import mockProjectsTest from 'mixins/mock/projectsTest.json'

export default {
  data() {
    return {
      isLoading: true,
      projectMock: null,
      mockConstructions,
      mockInverters,
      mockModules,
      mockProjectsTest,
      mockProjectsProd,
    }
  },
  computed: {
    mockProjects() {
      // return mockProjectsProd
      return process.env.NODE_ENV === 'production'
        ? mockProjectsProd
        : mockProjectsTest
    },
    projectsReal() {
      return this.query('project')
    },
    projects() {
      return this.projectsReal.map(projectReal => {
        const projectMock = this.mockProjects.find(mockProject => mockProject.id === projectReal.id) || {}

        const moduleMock = (projectMock.moduleIds || []).map(moduleId => {
          const module = this.mockModules.find(module => module.id === moduleId.id)
          return {
            ...module,
            count: moduleId.count,
          }
        })

        const inverterMock = this.mockInverters.find(inverter => inverter.id === projectMock.inverterId) || {}
        const constructionMock = this.mockConstructions.find(construction => construction.id === projectMock.constructionId) || {}

        return {
          ...projectReal,
          ...this.mockProjects.find(mockProject => mockProject.id === projectReal.id) || {},
          modules: moduleMock,
          inverter: inverterMock,
          construction: constructionMock,
        }
      }).sort((a, b) => a.order - b.order)
    },
    projectMain() {
      return this.projects.find(project => project.isMain)
    },
    projectsWithoutMain() {
      return this.projects.filter(project => project.id !== this.projectMain.id)
    },
    // project() {
    //   return {
    //     ...this.projectData,
    //     ...this.projectMock,
    //     module: this.module,
    //   }
    // },
    ...getters(),
  },
  methods: actions('FETCH_PROJECT'),
  async mounted() {
    await this.FETCH_PROJECT()

    // const slugCurrent = this.$route.params.slug
    // const projectMock = mockProjects.find(projectMock => projectMock.slug === slugCurrent)

    // if (projectMock) {
    //   this.projectMock = projectMock

    //   await this.FETCH_PROJECT(projectMock.id)
    //   this.isLoading = false
    // }
  },
}
</script>

<style lang="scss">
</style>
